export default {
  NONE: "none",
  CAP: "capitalize",
  UPP: "uppercase",
  LOW: "lowercase"
};
